// Lightweight client-side analytics. Fire-and-forget — never block the UI on
// telemetry. Auto-fires page_view on every route change via the useTrackRoute hook.
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { API } from '@/config/api';

const _sectionFromPath = (pathname) => {
  if (!pathname) return 'unknown';
  // strip leading slash, take first path segment
  const seg = pathname.split('/').filter(Boolean)[0];
  return seg || 'dashboard';
};

export const track = (event_type, section, action, metadata = {}) => {
  try {
    fetch(`${API}/track`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event_type, section, action, metadata }),
    }).catch(() => {});
  } catch (_e) { /* swallow */ }
};

/** Fire a page_view event on every route change. */
export const useTrackRoute = () => {
  const location = useLocation();
  useEffect(() => {
    const section = _sectionFromPath(location.pathname);
    track('page_view', section);
  }, [location.pathname]);
};

/** One-shot helper for feature usage. */
export const trackFeature = (section, action, metadata = {}) => {
  track('feature_use', section, action, metadata);
};
